module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-earmark-ruled-e901a12c.svg";